import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { Route, Routes } from 'react-router-dom';
import Customers from '../Pages/Customers';
import NewCustomer from '../Pages/Customers/NewCustomer';
import CustomerDetails from '../Pages/Customers/CustomerDetails';
import EditCustomer from '../Pages/Customers/EditCustomer';
import NewBooking from '../Pages/Bookings/NewBooking';
import NewTicket from '../Pages/Tickets/NewTicket';
import DashBoard from '../Pages/DashBoard/DashBoard';
import Receipt from '../Pages/Receipt/Receipt';
import BookingDetails from '../Pages/Bookings/BookingDetails';
import Bookings from '../Pages/Bookings/Bookings';
import EditBooking from '../Pages/Bookings/EditBooking';
import ReceiptDetails from '../Pages/Receipt/ReceiptDetails/ReceiptDetails';
import NewReceipt from '../Pages/Receipt/NewReceipt';
import EditReceipt from '../Pages/Receipt/EditReceipt';
import MessageStatuses from '../Pages/MessageStatuses';
import Requests from '../Pages/Requests/Requests';
import NewRequest from '../Pages/Requests/NewRequest/NewRequest';
import AddUser from '../Pages/OperationsSettings/Admins/AddUser/AddUser';
import Hotels from '../Pages/Hotels';
import HotelDetails from '../Pages/Hotels/HotelDetails/HotelDetails';
import NewHotel from '../Pages/Hotels/NewHotel/NewHotel';
import EditHotel from '../Pages/Hotels/EditHotel/EditHotel';
import OperationsSettings from '../Pages/OperationsSettings/OperationsSettings';
import RoomTypes from '../Pages/OperationsSettings/RoomTypes/RoomTypes';
import EditRequest from '../Pages/Requests/EditRequest/EditRequest';
import Admins from '../Pages/OperationsSettings/Admins/Admins';
import TicketDetails from '../Pages/Tickets/TicketDetails/TicketDetails';
import GiftVouchers from '../Pages/GiftVouchers/GiftVouchers';
import GiftVoucherDetails from '../Pages/GiftVouchers/GiftVoucherDetails/GiftVoucherDetails';
import NewGiftVoucher from '../Pages/GiftVouchers/NewGiftVoucher/NewGiftVoucher';
import Analytics from '../Pages/Analytics/Analytics';
import Packages from '../Pages/Packages/EditPackage';
import Partners from '../Pages/OperationsSettings/Partners';
import PackageDetails from '../Pages/Packages/PackageDetails';
import PackagesTable from '../Pages/Packages/PackagesTable';
import PackageNotifications from '../Pages/PackageNotifications';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    background: 'white'
  },
  fixedHeight: {
    height: 240
  }
}));

const MainContent = () => {
  const { content, appBarSpacer } = useStyles();

  return (
    <main className={content}>
      <div className={appBarSpacer} />
      <Container maxWidth="lg">
        <Routes>
          <Route path="/notifications" element={<PackageNotifications />} />
          <Route path="/packages/:id/edit" element={<Packages />} />
          <Route path="/packages/:id" element={<PackageDetails />} />
          <Route path="/packages" element={<PackagesTable />} />
          <Route path="/bookings/edit/:id" element={<EditBooking />} />
          <Route path="/receipts/:id" element={<ReceiptDetails />} />
          <Route path="/receipts/edit/:id" element={<EditReceipt />} />
          <Route path="/customers/details/:id" element={<CustomerDetails />} />
          <Route path="/customers/edit/:id" element={<EditCustomer />} />
          <Route path="/customers/new" element={<NewCustomer />} />
          <Route path="/bookings/new/:id" element={<NewBooking />} />
          <Route path="/tickets/new/:id" element={<NewTicket />} />
          <Route path="/tickets/:id" element={<TicketDetails />} />
          <Route path="/hotels/details/:id" element={<HotelDetails />} />
          <Route path="/hotels/new" element={<NewHotel />} />
          <Route path="/hotels/edit/:id" element={<EditHotel />} />
          <Route path="/operations/room-types" element={<RoomTypes />} />
          <Route path="/operations/partners" element={<Partners />} />
          <Route path="/operations/admins" element={<Admins />} />
          <Route path="/operations/admins/new" element={<AddUser />} />
          <Route path="/bookings/:id" element={<BookingDetails />} />
          <Route path="/bookings" element={<Bookings />} />
          <Route path="/receipts/new" element={<NewReceipt />} />
          <Route path="/receipts" element={<Receipt />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/messages" element={<MessageStatuses />} />
          <Route path="/requests/new" element={<NewRequest />} />
          <Route path="/requests/edit/:id" element={<EditRequest />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/hotels" element={<Hotels />} />
          <Route path="/gift-vouchers" element={<GiftVouchers />} />
          <Route path="/gift-vouchers/:id" element={<GiftVoucherDetails />} />
          <Route path="/gift-vouchers/new/:id" element={<NewGiftVoucher />} />
          <Route path="/operations" element={<OperationsSettings />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/" element={<DashBoard />} />
        </Routes>
      </Container>
    </main>
  );
};

export default MainContent;
